import request from '@/util/request'
export function deviceGroupTree() {
    return request({
        url: '/device/group/tree',
        method: 'post',
        data:{}
    })
}
